import Box from '@classify/react-core-components/Box';

import useCanDisplayMerchandising from 'Modules/training-merchandising/hooks/useCanDisplayMerchandising';
import useUserHasExpectedBenefit from 'Modules/currentUser/hooks/useUserHasExpectedBenefit';
import BigInfoBanner from 'Modules/training-merchandising/components/BigInfoBanner';
import JobOfferBanner from 'Modules/jobBoard/components/JobOfferBanner';
import {
  useCurrentUserContext,
  useUserExpectedBenefits,
} from '@openclassrooms/data-connect-web/users';
import { getActiveCountry } from '@openclassrooms/translations';

export default function BottomBanner({ ...otherProps }) {
  const canDisplay = useCanDisplayMerchandising();

  const isUserFrench = getActiveCountry() === 'FR';

  const userExpectsCareerImprovement = useUserHasExpectedBenefit([
    'expect_change_career',
    'expect_boost_career',
  ]);

  const userExpectsFirstJob = useUserHasExpectedBenefit('expect_first_job');

  const { userId } = useCurrentUserContext();
  const { data: expectedBenefits } = useUserExpectedBenefits(
    { userId },
    { enabled: Boolean(userId) }
  );
  const userHasNoBenefits = !expectedBenefits || expectedBenefits.length === 0;

  const canDisplayApprenticeshipBanner =
    canDisplay && (userExpectsCareerImprovement || userHasNoBenefits || !isUserFrench);

  const candDisplayJobOfferBanner = canDisplay && userExpectsFirstJob && isUserFrench;

  if (candDisplayJobOfferBanner === undefined || canDisplayApprenticeshipBanner === undefined) {
    return null;
  }

  return (
    <Box sx={{ my: 5 }}>
      {candDisplayJobOfferBanner && <JobOfferBanner {...otherProps} />}
      {canDisplayApprenticeshipBanner && <BigInfoBanner {...otherProps} />}
    </Box>
  );
}
